import React, { Component } from 'react';
import { QuoteData } from './components/QuoteData';
import { BrandImage } from './components/BrandImage';
import { ContactForm } from './components/ContactForm';
import { PrintButton } from './components/PrintButton';
import { Footer } from './components/Footer';

export default class App extends Component {
  displayName = App.name

  constructor(props) {
      super(props);

      this.state = { quote: null, loading: true };

      let search = window.location.search;
      let params = new URLSearchParams(search);
      let quoteCode = params.get('quoteCode');

      if (!quoteCode) {
          quoteCode = params.get('quotecode');
      }

      fetch(`api/quote?quoteCode=${quoteCode}`)
          .then(response => {
              if (response.ok) {
                  response.json()
                      .then(data => {
                          this.setState({ quote: data, loading: false });
                      });
              } else {
                  this.setState({ loading: false });
                  throw new Error("failed to locate your quote");
              }
          })
          .catch(err => {
              console.error(err.message);
          });
    }


  renderQuoteOld() {
      return (
          <div className="container">
                <div className="row">
                    <div className="col-md-10">
                      <h1>Your Training Quotation <small>Reference: {this.state.quote.reference} </small></h1>
                      <h2><small>Thank you for requesting a quotation from <strong>{this.state.quote.brandName}</strong>, the details are shown below:</small></h2>
                    </div>
                    <div className="col-md-2 visible-md visible-lg">
                      <BrandImage quoteData={this.state.quote}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                      <QuoteData quoteData={this.state.quote}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                      <ContactForm quoteData={this.state.quote}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2 col-md-offset-10">
                        <PrintButton />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                      <Footer quoteData={this.state.quote} />
                    </div>
                </div>
            </div>
      );
    }


  renderQuote() {
      return (
          <div className="container">
              <div className="row">
                  <div className="col-md-12">
                      <BrandImage quoteData={this.state.quote} />
                  </div>
              </div>
                <div className="row">
                    <div className="col-md-10">
                      <h1 style={{ color: '#00a48a' }}>Your Training Quotation</h1><h3 style={{ marginTop: 0 }}>Reference: {this.state.quote.reference}</h3>
                        <h2><small>Thank you for requesting a quotation from <strong>{this.state.quote.brandName}</strong>, the details are shown below:</small></h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <QuoteData quoteData={this.state.quote} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ContactForm quoteData={this.state.quote} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2 col-md-offset-10">
                        <PrintButton />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Footer quoteData={this.state.quote} />
                    </div>
                </div>
            </div>
      );
  }


    renderAlert(message, alertLevel) {
        let alertClass = `alert ${alertLevel} fade in text-center`;

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1" style={{marginTop : "20px" }}>
                        <div className={alertClass} role="alert">
                            {message}
                        </div>
                    </div>                    
                </div>
            </div>
        );
    }

    render() {

       let quoteDisplay = this.renderAlert("Retrieving your quote, please wait...", "alert-info");

       if (!this.state.loading) {
           if (this.state.quote) {
               quoteDisplay = this.renderQuote();
           } else {
               quoteDisplay = this.renderAlert("We were unable to find your quote. Please contact your sales agent using the telephone number on your quote email.","alert-danger");
           }
       }

       return (
           <div>
               {quoteDisplay}
           </div>
       );
   }
}
